var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 2.15533C10.1759 1.84274 9.75207 1.66709 9.31008 1.66699H3.33341C2.89139 1.66699 2.46746 1.84259 2.1549 2.15515C1.84234 2.46771 1.66675 2.89163 1.66675 3.33366V9.31033C1.66684 9.75232 1.8425 10.1762 2.15508 10.4887L9.40842 17.742C9.78718 18.1184 10.2995 18.3296 10.8334 18.3296C11.3674 18.3296 11.8797 18.1184 12.2584 17.742L17.7417 12.2587C18.1181 11.8799 18.3294 11.3676 18.3294 10.8337C18.3294 10.2997 18.1181 9.78742 17.7417 9.40866L10.4884 2.15533Z",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 6.66634C6.48004 6.66634 6.66659 6.47979 6.66659 6.24967C6.66659 6.01956 6.48004 5.83301 6.24992 5.83301C6.0198 5.83301 5.83325 6.01956 5.83325 6.24967C5.83325 6.47979 6.0198 6.66634 6.24992 6.66634Z",
    fill: "#143B6B",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoDiscount);
export default __webpack_public_path__ + "static/media/promo-discount.2f3ca5ce5eef8c30b6edfc6b0dc41f6a.svg";
export { ForwardRef as ReactComponent };